import config from '@trend-dev/trendtech-ui/config/trendrealty';
import { setDI } from '@trend-dev/trendtech-ui/DI';

setDI({ config, namespace: 'trendrealty' });
